export default "__VITE_ASSET__eeabed27__"